<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	export default {
		props: {
			shuiwbmdialog: {
				type: Boolean,
				default: false
			}
		},
		data: function() {
			return {
				//表格
				headData: getdata().headData,
				tableData: [],
				pagination: getdata().pagination,
				tablekey: 0,
				Danxu: '',
				//大类数据
				LargeClassData: [],
				selectData:{},
				shuil:"",
				tree: 0,
				type: "",
				sort: "",
				order: "",
				likeSearch: ""
			};
		},
		watch: {
			shuiwbmdialog: function(indexVal, oldVal) {
				if (indexVal) {
					this.tableData = []
					this.LargeClassData = []
					this.type = ""
					this.selectData = ""
					this.likeSearch = ""
					this.getGoodsSwbmTreeData()
				}
			}
		},
		created() {
			this.getGoodsSwbmTreeData()
		},
		mounted() {},
		methods: {
			/* 获取全部税收分类数据 */
			getGoodsSWBMList() {
				let params = {
					page: this.pagination.pageNum,
					limit: this.pagination.pageSize,
					param: {
						likeSearch: this.likeSearch,
						parentCode: this.type
					},
					type: this.type,
					sort: this.sort,
					order: this.order
				};
				this.$https.fetchPost('/master/getGoodsSwbmListNew', params).then(res => {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
				});
			},
			handleNodeClick(data) {
				if (data.code != 0) {
					this.type = data.code;
					this.selectData = ""
					this.getGoodsSWBMList();
				}
			},
			getGoodsSwbmTreeData() {
				this.$https.fetchPost('/master/getGoodsSWBMTree').then(res => {
					this.getGoodsSWBMList();
					this.$nextTick(() => {
						this.LargeClassData = [{
							code: '0',
							parentCode: '',
							name: '全部',
							data: null,
							children: res.data.data
						}];
						this.tree = 0;
						getCheckedAll(this.LargeClassData[0]);
						
						function getCheckedAll(e) {
							this.tree++;
							if (e.children) {
								e.children.forEach(v => {
									getCheckedAll(v);
								});
							}
						}
					});
				});
			},
			//保存
			Baocjen() {
				if (!this.selectData || this.selectData == {}) {
					this.$message.error('请选择税务编码!');
					return false
				}
				this.$emit("Baocjen", this.selectData)
			},
			//筛选返回
			forSearchScreeningBox(obj) {
				console.log(obj);
			},
			//表格字段排序
			sortchange(e) {
				console.log(e);
				this.order = e.prop;
				if (e.order == 'ascending') {
					this.sort = 'ASC';
				} else if (e.order == 'descending') {
					this.sort = 'DESC';
				} else {
					this.sort = '';
				}
				this.getGoodsSWBMList()
			},
			//显示条数
			sizechange(e) {
				this.pagination.pageSize = e;
				this.getGoodsSWBMList()
			},
			//显示页码
			currentChange(e) {
				this.pagination.pageNum = e;
				this.getGoodsSWBMList()
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>